/**
 * The two pages Stripe sends a shopper back to, named once for both sides.
 *
 * The Worker writes these into a Checkout Session's `success_url` and
 * `cancel_url` (./session.ts); the SPA routes them (src/route-table.tsx).
 * They live here, in the Worker, because the Worker is what Stripe holds the
 * URL from — the page has to be wherever the Worker said it would be, not the
 * other way around.
 *
 * Root-relative on purpose. Every checkout host is a custom domain serving
 * this app at `/` (wrangler.jsonc). The monorepo's `/checkout/return` was an
 * artifact of its subdomain-rewrite proxy, which mapped
 * `checkout.sara.ai/<path>` onto `(subdomains)/checkout/<path>`; carried into
 * this Worker it sent every paid shopper to the SPA's not-found page.
 */
export const RETURN_PAGE_PATH = "/return";
export const CANCEL_PAGE_PATH = "/cancel";

/** Where Stripe sends a shopper after paying, and where a paid order bounces. */
export function returnPageUrl(
  origin: string,
  sessionId: string,
  orderId: string,
): string {
  return `${origin}${RETURN_PAGE_PATH}?session_id=${encodeURIComponent(
    sessionId,
  )}&order_id=${encodeURIComponent(orderId)}`;
}

/** Where Stripe sends a shopper who backs out of the hosted page. */
export function cancelPageUrl(origin: string, sessionId: string): string {
  return `${origin}${CANCEL_PAGE_PATH}?session_id=${encodeURIComponent(
    sessionId,
  )}`;
}
